<template>
  <div>
    <div style="display: flex; align-items: center; margin-top: 10px;margin-bottom: 10px; width: 100%;">
     <div style="display: flex; align-items: center; flex-grow: 1;">
        <el-button size="small" type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <el-button size="small" type="danger" v-if="['ADMIN', 'MANAGER', 'SALES_ASSI_MANAGER'].includes(role)"
          icon="el-icon-delete" @click="handleDelete()">批量删除</el-button>
        <el-button size="small" type="warning" v-if="['ADMIN', 'MANAGER'].includes(role)" icon="el-icon-edit"
          @click="openWhiteList()">修改白名单</el-button>
        <el-button size="small" type="warning" v-if="['ADMIN'].includes(role)" icon="el-icon-edit"
          @click="changeSalesUser()">批量更改客户联系人销售</el-button>
      </div>
      <export-components v-if="['ADMIN','MANAGER','SALES_MANAGER'].includes(role)" :apiFunction="exportContacts" :requestData="getSearch({})"
        :option="option" @sendData=getSearchData></export-components>
    </div>
    <div style="color:red;font-size: 16px;font-weight: bold;margin-bottom: 20px">
      注：创建客户的时候会检查：手机号/邮箱的唯一性，即创建的手机号/邮箱会检查数据库内是否有一样的</div>
    <div style="width:100%;">
      <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection"
        @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
        :table-col-check="{isShow:true,name:'Customer-User4'}" ref="wMyTable" :page="page"
        @pageChange="handlePagePagination" :isShowRowSelection="true">
        <div slot="operation" slot-scope="{record}">
          <el-button size="mini" type="primary" v-if="['ADMIN', 'MANAGER', 'SALES_ASSI_MANAGER'].includes(role) || !!record.editFlag"
            @click="handleEdit(record)">编辑</el-button>
          <!--          <el-button size="mini" type="warning" @click="handleInfo(record)">详情</el-button>-->
          <el-button size="mini" v-if="['ADMIN','MANAGER','SALES_ASSI_MANAGER'].includes(role)" type="danger"
            @click="handleDelete(record)">删除</el-button>
        </div>
        <div slot="remainingAmount" slot-scope="{text,record,index}">
          <ex-fold-line
            :scope="{time:timeData,customerContactsInvoiceIds:record.customerContactsInvoiceIds,record:record['contactsAmountVo'],data:{ key: 'customerContactsName', title: '委托方（甲方）', value: record.contactName }, index}"></ex-fold-line>
        </div>
        <div slot="filterAmount" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
          style="padding: 8px; position: relative; z-index: 9999 !important;">
          <div style="padding: 0 15px;margin-bottom: 15px">
            <el-radio-group v-model="type" size="small">
              <el-radio-button label="number">{{'按值查询'}}</el-radio-button>
              <el-radio-button label="range">{{'按范围查询'}}</el-radio-button>
            </el-radio-group>
          </div>
          <div style="padding: 0px 15px" v-if="type === 'range'">
            <el-input v-model="selectedKeys[0]" size="small" placeholder="最小值" style="width: 120px;"></el-input>
            -
            <el-input v-model="selectedKeys[1]" size="small" placeholder="最大值" style="width: 120px;"></el-input>
          </div>
          <div style="padding: 0px 15px" v-if="type === 'number'">
            <el-input v-model="selectedKeys[0]" size="small" :placeholder="'搜索' + column.title"></el-input>
          </div>
          <div style="display: flex;padding: 15px">
            <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
              @click="() => handleSearch(setSelectedKeys, selectedKeys, confirm, column, clearFilters, type)">
              搜索
            </a-button>
            <a-button size="small" style="width: 90px" @click="() => handleReset(column, clearFilters)">取消
            </a-button>
          </div>
        </div>
      </w-table>
      <add-customer-user v-if="showAddEditCusDialog" :show-dialog="showAddEditCusDialog" :selectType="selectType"
        :select-detail="selectDetail" @submit="closeAddEditCusDialog">
      </add-customer-user>
      <picture-loading v-if="loading"></picture-loading>
      <contact-white-list :show-dialog="showWhiteList" v-if="showWhiteList"
        @submit="closeWhiteList"></contact-white-list>
      <change-contact-sales :show-dialog="showChangeSales" v-if="showChangeSales"
        :contacts="changeSalesContacts" @submit="closeChangeSales"></change-contact-sales>
    </div>
  </div>
</template>

<script>

import {deletecus, getUserPage} from "@/api/dilivery/customer/user";
import {customerUser} from "@/utils/data/tableCol/customer/customerUser";
import AddCustomerUser from "@/components/customer/AddCustomerUser.vue";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldLine from "@/components/ExFoldLine.vue";
import {getDataInLocalStorage} from "@/utils/localStorage";
import {exportContacts} from "@/api/dilivery/export";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import ExportComponents from "@/components/ExportComponents.vue";
import { tableOperationMixin } from "@/mixins/tableOperation";
import ContactWhiteList from "@/components/customer/ContactWhiteList.vue"
import ChangeContactSales from "@/components/customer/ChangeContactSales.vue"
import _ from 'lodash';

export default {
  name: "CustomerUser",
  components: { ExportComponents, PictureLoading, ExFoldLine, TableHeadNote, AddCustomerUser, ContactWhiteList, ChangeContactSales },
  mixins: [tableOperationMixin],
  data() {
    return {
      loading:true,
      role: '',
      type:'number',
      title: '添加客户',
      searchConditionTag: [],//搜索tag
      sortConditionTag: [],
      tableData: [],
      selectable: [],
      showAddEditCusDialog: false, //控制编辑页面显示与隐藏
      selectDetail: '',
      selectType: {},
      option: [
        {label: '创建时间', value: 'createTime'},
      ],
      showWhiteList:false,
      showChangeSales:false,
      changeSalesContacts:[],
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      }
    }
  },
  computed: {
    columns() {
      return JSON.parse(JSON.stringify(customerUser(this.searchConditionTag || {})))
    },
    timeData() {
      // 公共数据项
      const commonItems = [
        { name: '剩余金额', time: 'remainingAmount', router: '', data: [] },
        { name: '预付款合同金额', time: 'prepaymentsAmount', router: '合同申请',
          data: [
            { key: 'status', title: '审核状态', value: '已通过' },
            { key: 'contractType', title: '合同分类', value: '预付款' },
            { key: 'sourceIntentProjectId', title: '合同来源', value: '销售申请' }
          ]},
        { name: '预付款增值金额', time: 'addedAmount', router: '合同申请',
          data: [
            { key: 'status', title: '审核状态', value: '已通过' },
            { key: 'contractType', title: '合同分类', value: '预付款' },
            { key: 'sourceIntentProjectId', title: '合同来源', value: '销售申请' }
          ]},
        { name: '正式合同金额', time: 'formalAmount', router: '合同申请',
          data: [
            { key: 'status', title: '审核状态', value: '已通过' },
            { key: 'contractType', title: '合同分类', value: '正式' }
          ]},
        { name: '正式合同结余金额', time: 'formalBalanceAmount', router: '合同申请',
          data: [
            { key: 'status', title: '审核状态', value: '已通过' },
            { key: 'contractType', title: '合同分类', value: '预付款' },
            { key: 'sourceIntentProjectId', title: '合同来源', value: '正式合同结余' }
          ]},
        { name: '扣款金额', time: 'deductionAmount', router: '合同申请',
          data: [
            { key: 'status', title: '审核状态', value: '已通过' },
            { key: 'contractType', title: '合同分类', value: '扣款' }
          ]},
        { name: '预付款转移扣款金额', time: 'transferChargebacksAmount', router: '', data: [] },
        { name: '预付款转移到款金额', time: 'transferRecordedAmount', router: '', data: [] },
      ];
      // 特殊角色需要添加的额外数据项
      const additionalItems = [
        { name: '预付款到款金额', time: 'prepaymentsReceivedAmount', router: '到款信息',
          data: [
            { key: 'contact', title: '联系人', value: 'PREPAYMENTS' }
          ]},
        { name: '正式合同到款金额', time: 'formalReceivedAmount', router: '到款信息',
          data: [
            { key: 'contact', title: '联系人', value: 'FORMAL' }
          ]}
      ];

      // 判断角色并返回对应数据
      if (['SALES_MANAGER', 'SALES_ASSI','SALES_ASSI_MANAGER', 'SALES'].includes(this.role)) {
        return commonItems;
      } else {
        return [...commonItems, ...additionalItems];
      }
    }
  },
  created() {
    this.role = getDataInLocalStorage('role')
  },
  mounted() {
    this.getData()
  },
  methods: {
    openWhiteList() {
      this.showWhiteList = true
    },
    closeWhiteList(type) {
      this.showWhiteList = false
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    exportContacts,
    //表格的选择框
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id))
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    // 获取数据
    getData(type) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (type) {
        params['page.current'] = 1
        params['page.size'] = 10
      }
      this.sortConditionTag.forEach(item => {
        params["order"] = item.colName + "." + item.order
      })
      let sendData = {}
      sendData = this.getSearch(sendData)
      getUserPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (item.key === 'remainingAmount') {
          if(item.value.includes('至')) {
            sendData["query#" + item.key + ".BETWEEN"] = value.split('至').join(',')
          }else {
            sendData["query#" + item.key + ".EQ"] = value
          }
        } else if (['companyName','salesperson','groupName'].includes(item.key)) {
          sendData[item.key] = value
        } else if (this.option.map(it => it.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = value
        } else {
          sendData["query#" + item.key + ".LIKE"] = value
        }
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    //编辑
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        this.selectDetail = row
        this.selectType = {
          type: 'edit'
        }
      } else {
        this.selectType = {
          type: 'add'
        }
        this.selectDetail = ''
      }
      this.showAddEditCusDialog = true
    },
    // 关闭编辑、增加、批量添加弹出框
    closeAddEditCusDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() =>{
        this.showAddEditCusDialog = false
      })
    },
    //批量更改客户联系人销售
    changeSalesUser() {
      if (this.selectable.length <= 0) {
        this.$messageUi.error('请勾选要修改关联销售的客户联系人')
        return
      }
      this.changeSalesContacts = [...this.selectable]
      this.showChangeSales = true
    },
    // 关闭批量更改客户联系人销售弹窗
    closeChangeSales(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.$refs.wMyTable.selectedRowKeys = []
        this.selectable = []
        this.showChangeSales = false
        this.changeSalesContacts = []
      })
    },
    //删除
    handleDelete(row) {
      let ids = []
      if (row && row.id) {
        ids.push(row.id)
      } else {
        if (this.selectable.length > 0) {
          ids = this.selectable.map(item => item.id)
        } else {
          this.$messageUi.error('请勾选要批量删除的数据')
          return
        }
      }
      this.$confirmUi('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        let param = {
          "ids" : ids.join(',')
        }
        deletecus(param).then(res => {
          if (res.code === 200) {
            this.$messageUi({
              type: 'success',
              message: '删除成功!'
            })
            const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize)
            this.page.currentNum = this.page.currentNum > totalPage ? totalPage : this.page.currentNum
            this.page.currentNum = this.page.currentNum < 1 ? 1 : this.page.currentNum
            this.getData()
          }
        }).catch(err => {
        })
      }).catch(() => {

      })
    },
  }
}
</script>

<style scoped>
.status-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
